<template>
    <ui-crud :read-only="true" title="Emails" subtitle="See outgoing emails sent by you." :fetch="fetch">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search" @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :truncateTitle="true"
                :title="item.recipients()"
                :subtitle="[item.email_type]"
                :subtext="item.subject"
                :icon='item.has_attachment ? `<i class="far fa-paperclip"></i>` : false'
                :metadata="item.status_object.status_at"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem }">
            <emails-list-show :item="selectedItem" :edit="false"></emails-list-show>
        </template>
    </ui-crud>
</template>

<script>
import { Email } from '@models'
import EmailsListShow from "./EmailsListShow.vue";

export default {
  components: {EmailsListShow},
    data () {
        return {
            search: '',
        }
    },
    methods: {
        async fetch () {
            return await Email.all(this.search)
        },
    }
}
</script>
